




















































































import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import BaseTab from './baseTab'
import dayjs from 'dayjs'
import { Route } from 'vue-router'
import store from '@/store'
import { ExStore } from 'vuex'
import { DateString } from '@/types/utils'
import { Labotest, LabotestItem } from '@/types/labotest'
import { Tabs, TabSettingName } from '@/constants/appSettings'

const TODAY = dayjs()

const handleChangeRounting = (to: Route, next: () => void) => {
  const patientId = Number(to.params.patientId)
  const year = Number(to.query.year) || new Date().getFullYear()
  store.dispatch('labotest/fetch', { patientId, year })
  next()
}

@Component({
  components: {
    Loading: () => import('@/components/common/loadings/Index.vue')
  }
})
export default class LaboTestTab extends mixins(BaseTab) {
  $store!: ExStore

  @Prop({ default: null, type: Number }) year!: number | null
  @Prop(Number) patientId!: number

  get labotestItems() {
    return this.$store.getters['labotest/itemsForIndex']
  }

  get selectedYear() {
    return this.year || TODAY.year()
  }

  set selectedYear(year) {
    this.$router.push({
      name: Tabs[TabSettingName.laboTest].routeName,
      query: { year: String(year) }
    })
  }

  get yearOptions() {
    const start = 2018
    const end = TODAY.year()
    return [...new Array(end - start + 1)].map((_, i) => end - i)
  }

  get patient() {
    return this.$store.getters['patient/currentPatient']
  }

  get labotests() {
    return this.$store.getters['labotest/labotests']
  }

  get loading() {
    return this.$store.getters['labotest/loading']
  }

  getAnomaryStatus(data: Labotest, code: string) {
    const anomary = this.isItemValueAnomary(data, code)
    if (!anomary) return ''
    return /L/.test(anomary) ? 'txt_blue' : 'txt_red'
  }

  isItemValueAnomary(data: Labotest, code: string) {
    const item = data.items.find(item => item.itemCode === code)
    return item ? item.abnormalFlag : false
  }

  getItemValue(data: Labotest, code: string) {
    const item = data.items.find(item => item.itemCode === code)
    return item ? item.resultValue : ''
  }

  formatDispayDate(dateString: DateString) {
    const date = dayjs(dateString)
    return date.format('YYYY/MM/DD')
  }

  getSingleByteString(str: string) {
    return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
    })
  }

  getReferenceRange(item: LabotestItem) {
    return this.getSingleByteString(item.referencesRange)
  }

  async beforeRouteEnter(to: Route, from: Route, next: () => void) {
    await handleChangeRounting(to, next)
  }

  async beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    await handleChangeRounting(to, next)
  }
}
